import { render, staticRenderFns } from "./ManageSuperAdmins.vue?vue&type=template&id=583206bf&scoped=true"
import script from "./ManageSuperAdmins.vue?vue&type=script&lang=js"
export * from "./ManageSuperAdmins.vue?vue&type=script&lang=js"
import style0 from "./ManageSuperAdmins.vue?vue&type=style&index=0&id=583206bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583206bf",
  null
  
)

export default component.exports